module.exports = __webpack_public_path__ + "media/elevadizo/buqueDerecha-cff67cd8.png";